module.exports = __webpack_public_path__ + "img/43.89642cbb.jpg";